import React from 'react'
import { Pagination } from 'react-bootstrap'

import styles from './styles/paginator.scss'

export default class Paginator extends React.Component {
  render() {
    const { totalCount, page, limit, onPaginate } = this.props

    const pages = parseInt(Math.ceil(totalCount / limit))

    if (pages <= 1 || isNaN(pages)) {
      return null
    }

    return (
      <div style={{ textAlign: 'center' }}>
        <Pagination
          prev
          next
          first
          last
          items={pages}
          activePage={page}
          bsSize="medium"
          maxButtons={10}
          onSelect={eventKey => onPaginate(eventKey)}
          className={styles.pagination}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Paginator.js